import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, nullDate, TDate } from '../../public/utility'
import { doGetOverTimeApply, doSaveOverTimeApply, doDeleteOverTimeApply, doGetHours } from '../../reducers/actions'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'
import { doOverTimeApplyAction } from '../../business/OverTimeApplyAction'
class SealInformation extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    componentDidMount = () => {
        const { id } = this.props
        Tyan.doPostEvent('GetseaManagement', {
            data: {id},
            onEnd: ({ errorMessage, initValues基本信息,optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else if (initValues基本信息) {
                    this.setState({optionsParas, id, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerSave = () => {
        const { dispatch, onSave, onClose } = this.props
        const { id, changedValues基本信息, initValues基本信息 } = this.state
        Tyan.doPostEvent('SaveseaManagement', {
            data: {id,changedValues基本信息},
            onEnd: ({ errorMessage, initValues基本信息,optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else{
                    // this.setState({optionsParas, id, initValues基本信息, changedValues基本信息: {} })
                    Ext.toast('执行成功')
                    onClose && onClose()
                    onSave && onSave()
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }



    bChanged = () => {
        return hasChangedValues(this)
    }

    bSave = () => {
        const { initValues基本信息, changedValues基本信息 } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return Object.keys(changedValues基本信息).length > 0
    }

    handlerDelete = () => {
        const { dispatch, onClose, onSave } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
        Tyan.doPostEvent('DeleteseaManagement', {
            data: {id},
            onEnd: ({ errorMessage,  }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('执行成功')
                    onClose && onClose()
                    onSave && onSave()
                }
            }
        }))
    }

    fieldset基本信息 = () => {
        const { initValues基本信息, changedValues基本信息,optionsParas,id } = this.state
        const values = { ...initValues基本信息, ...changedValues基本信息 }
        return [
            { _text: '印章名称', minWidth: '45%', disabled: values.授权记录.length >0, },
            { _select: '保管人', minWidth: '45%', disabled: values.授权记录.length >0, required: true },
            { _text: '用途说明', minWidth: '90%', maxRows: 3, required: true, disabled: false },
        ]
    }

    fieldset授权记录 = () => {
        const { initValues基本信息, changedValues基本信息,optionsParas,id } = this.state
        return [{
            _grid: '', name: '授权记录', rowNumbers: true, /*minRows: 3, maxRows: 11, */ height: '100%',
            columns: [
                { _text: '授权人', flex: 2 },
                { _text: '被授权人', flex: 2 },
                { _text: '授权时间', flex: 2 ,align: 'left'},
            ],
            buttons: [
            ],
        }]
    }

    render() {
        const { showMessage: Message, showBody: Body, readOnly } = this.props
        const { errorMessage, id, initValues基本信息, } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth="1100"
            controls={
                readOnly ? [
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose }
                ] : [
                        { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !this.bSave(), },
                        { _button: '删除', icon: 'trash-o', ui: 'action decline alt', handler: this.handlerDelete, cdt: () => id > 0},
                        { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '印章管理', name: '基本信息', _fieldset: this.fieldset基本信息(), docked: 'top', height: '60%' },
                    { title: '授权记录', name: '基本信息', _fieldset: this.fieldset授权记录(), fullblock: true },
                ]
            }
        />
    }
}

export default connect()(SealInformation)